// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"5258ccfd","72":"51215e3d","166":"41feefcc","400":"01aa08a5","412":"d6437824","439":"0df0958d","552":"28ef9d4a","569":"3c078005","752":"6f61e936","813":"5e69ac89","840":"4b11391d","858":"1dc141d5","915":"de50d0c3"}[chunkId] + ".chunk.js";
};